module.exports = __webpack_public_path__ + "assets/onboarding-desktop.0a039f068270ab252d09d6d68e36d503.png";